var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23 3.00999C23 3.00999 20.982 4.20199 19.86 4.53999C19.2577 3.84751 18.4573 3.35669 17.567 3.13392C16.6767 2.91116 15.7395 2.96719 14.8821 3.29445C14.0247 3.62171 13.2884 4.2044 12.773 4.96371C12.2575 5.72303 11.9877 6.62233 12 7.53999V8.53999C10.2426 8.58556 8.50127 8.19581 6.93101 7.40544C5.36074 6.61507 4.01032 5.44863 3 4.00999C3 4.00999 -1 13.01 8 17.01C5.94053 18.408 3.48716 19.1089 1 19.01C10 24.01 21 19.01 21 7.50999C21 7.23199 20.972 6.95399 20.92 6.67999C21.94 5.67399 23 3.00999 23 3.00999Z","stroke":"#1E2226","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Twitter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
